export { default } from './QuickOrder.container';
